import React from 'react';
import { Link } from 'react-router-dom';
import FitnessProfileSectionCard from '../shared/FitnessProfileSectionCard';
import { AI_TRAINER_PERSONALITIES } from '../../../constants/aiTrainerPersonalities';

function trainerStatusLabel(profile) {
	if (profile.ai_trainer_needs_setup) {
		return { label: 'Not set up', tone: 'text-gray-500 dark:text-dark-text-secondary' };
	}

	if (!profile.ai_trainer_enabled) {
		const persona = AI_TRAINER_PERSONALITIES.find((p) => p.id === profile.ai_trainer_personality);
		return {
			label: persona ? `${persona.label} · Paused` : 'Paused',
			tone: 'text-yellow-700 dark:text-yellow-400'
		};
	}

	const persona = AI_TRAINER_PERSONALITIES.find((p) => p.id === profile.ai_trainer_personality);
	return {
		label: persona ? `${persona.label} · Active` : 'Active',
		tone: 'text-green-700 dark:text-green-400'
	};
}

export default function FitnessProfileAiTrainerSection({ profile }) {
	const status = trainerStatusLabel(profile);
	const needsSetup = profile.ai_trainer_needs_setup ?? !profile.ai_trainer_configured_at;
	const trainerUrl = `/ai-trainer?profile_id=${profile.id}`;
	const settingsUrl = `${trainerUrl}&settings=1`;

	return (
		<div className="mt-4">
			<FitnessProfileSectionCard title="AI Trainer">
				<p className={`text-sm font-medium ${status.tone}`}>{status.label}</p>
				<p className="mt-2 text-sm text-gray-600 dark:text-dark-text-secondary">
					Science-backed coach with proactive reminders for challenges, goals, and habits.
				</p>
				<div className="mt-4 flex flex-wrap gap-3">
					{needsSetup ? (
						<Link
							to={trainerUrl}
							className="inline-flex rounded-lg bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700 dark:bg-blue-600 dark:hover:bg-blue-500"
						>
							Set up trainer
						</Link>
					) : (
						<>
							<Link
								to={trainerUrl}
								className="inline-flex rounded-lg bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700 dark:bg-blue-600 dark:hover:bg-blue-500"
							>
								Open trainer
							</Link>
							<Link
								to={settingsUrl}
								className="inline-flex rounded-lg border border-gray-300 dark:border-dark-border px-4 py-2 text-sm font-medium text-gray-700 dark:text-dark-text hover:bg-gray-50 dark:hover:bg-dark-bg"
							>
								Edit settings
							</Link>
						</>
					)}
				</div>
			</FitnessProfileSectionCard>
		</div>
	);
}
